export const REPORT_METHOD_NAME = 'report';

export type AuditMethodName = typeof REPORT_METHOD_NAME;

/**
 * The failure side of {@link TreasuryService}: the treasury books what a stream earned, the audit
 * books why one died. Installing it changes nothing about the outcome — an `error` notification is
 * terminal whether or not anything is listening — only whether the failure is reported at all, which
 * is exactly what an RxJS `error` callback buys and all it buys. Saving the stream is `catchError`'s
 * job, and that happens upstream, inside the pipe.
 */
function reportFailure(message: string): string {
  return message;
}

export class AuditService {
  static readonly report = reportFailure;
}
